import * as constants from './constants';
import axios from 'axios';

export const personRegisterClick = () => ({
    type: constants.PERSON_REGISTER_CLICK
})
export const companyRegisterClick = () => ({
    type: constants.COMPANY_REGISTER_CLICK
})
export const firstNextStepClick = () => ({
    type: constants.FIRSR_NEXT_STEP_CLICK
})
export const secondNextStepClick = () => ({
    type: constants.SECOND_NEXT_STEP_CLICK
})
export const thirdNextStepClick = () => ({
    type: constants.THIRD_NEXT_STEP_CLICK
})
export const onPersonUsernameChange = (e) => ({
    type: constants.ON_PERSON_USERNAME_CHANGE,
    elem: e.target
})
export const onPersonUserPhoneorEmailChange = (e) => ({
    type: constants.ON_PERSON_PHONE_OR_EMALI_CHANGE,
    elem: e.target
})
export const onPersonUserPwdChange = (e) => ({
    type: constants.ON_PERSON_USER_PWD_CHANGE,
    elem: e.target
})
export const onPersonUserConfirmPwdChange = (e) => ({
    type: constants.ON_PERSON_USER_CONFIRM_PWD_CHANGE,
    elem: e.target
})
export const personUserCodeChange = (e) => ({
    type: constants.ON_PERSON_USER_CODE_CHANGE,
    elem: e.target
})
export const CheckReadAgreementChange = (e) => ({
    type: constants.ON_CHECK_READ_AGREEMENT_CHANGE,
    elem: e.target
})

// 注册内容填写完成，发送请求
const changePersonRegister = () => ({
    type: constants.CHANGE_PERSON_REGISTER,
    value: true
})
export const personRegisterBtnClick = (usernameElem, emailorphoneElem, passwordElem, confirmPWDElem, checkcodeElem, checkboxElem) => {
    return (dispatch) => {
        if (usernameElem.getAttribute("data-validate") !== "1") {
            alert("请输入正确的昵称");
        } else if (emailorphoneElem.getAttribute("data-validate") !== "1") {
            alert("请输入正确的电话号码");

        } else if (passwordElem.getAttribute("data-validate") !== "1") {
            alert("请输入正确的密码");

        } else if (confirmPWDElem.getAttribute("data-validate") !== "1") {
            alert("请输入正确的确认密码");

        } else if (checkcodeElem.getAttribute("data-validate") !== "1") {
            alert("请输入正确的验证码");
        } else if (checkboxElem.getAttribute("data-validate") !== "1") {
            alert("请阅读并同意条款");

        } else {
            console.log("code is:" + checkcodeElem.value);
            let uinfo = {
                "Phone": emailorphoneElem.value,
                "Password": passwordElem.value,
                "PhoneCheckNum": checkcodeElem.value,
                "UserName": usernameElem.value
            };
            axios.post('https://api.chinaaudio.net.cn/UserP/tools/UserAPI/UserP/AddUserPhone', uinfo).then((res) => {
                console.log(res.data);
                let r = JSON.parse(res.data);
                console.log(r.code);
                if (r.code === 200) {
                    dispatch(changePersonRegister())
                } else {
                    alert('注册失败,请确认填写的信息内容是否正确')
                }
            })
        }
        dispatch(changePersonRegister());
    }
}

// 发送验证码
const sendCheckNum = () => ({
    type: constants.SEND_CHECK_NUM,
    value: true
})
export const SendCodeBtnClick = (emailorphoneElem) => {
    return (dispatch) => {
        console.log(emailorphoneElem.value)
        axios.post('https://api.chinaaudio.net.cn/UserP/tools/UserAPI/UserP/checkNum', {
            "Phone": emailorphoneElem.value
        }).then((result) => {
            console.log(result)
            if (result) {
                dispatch(sendCheckNum())
            }
        })
    }
}